import { MouseEvent, memo } from 'react'
import { Box, BoxProps, Tooltip } from '@chakra-ui/react'

import { useValidatePermissions } from 'hooks'

type Props = BoxProps & {
  children: JSX.Element
  permissions?: Array<string | undefined>
}

function Trigger({ permissions = [], children, onClick, ...rest }: Props) {
  const { validatePermissions } = useValidatePermissions()

  const userHasPermission = permissions.length === 0 ? true : validatePermissions(permissions)

  function dispatchOnClick(event: MouseEvent<HTMLDivElement>) {
    if (!userHasPermission) return
    if (onClick) onClick(event)
  }

  return (
    <Tooltip isDisabled={userHasPermission} label="Você não tem permissão" placement="top">
      <Box
        width="100%"
        className={userHasPermission ? 'accessible' : ''}
        opacity={userHasPermission ? '1' : '0.5'}
        // tabIndex={userHasPermission ? 0 : -1}
        cursor={userHasPermission ? 'pointer' : 'not-allowed'}
        onClick={(event) => dispatchOnClick(event)}
        {...rest}
      >
        {children}
      </Box>
    </Tooltip>
  )
}

export default memo(Trigger)
